var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMganusmage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "13japk9g1b",
    cx: 0.503,
    cy: 0.497,
    r: 0.503,
    gradientTransform: "matrix(.994 0 0 1 .003 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#406afe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4688fe"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "8fl10j4bhe",
    cx: 0.503,
    cy: 0.497,
    r: 0.503,
    xlinkHref: "#13japk9g1b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bqb013tc4f",
    cx: 0.503,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#13japk9g1b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "illud99f7g",
    cx: 0.497,
    cy: 0.497,
    r: 0.503,
    gradientTransform: "matrix(.995 0 0 1 .003 0)",
    xlinkHref: "#13japk9g1b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3ru00dxsh",
    cx: 0.505,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#13japk9g1b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cdbvh6hefi",
    cx: 0.505,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#13japk9g1b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "z9t7w77irj",
    cx: 0.503,
    cy: 0.497,
    r: 0.503,
    gradientTransform: "matrix(.993 0 0 1 .003 0)",
    xlinkHref: "#13japk9g1b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pnoku98cbc",
    x1: 0.5,
    y1: -0.028,
    x2: 0.5,
    y2: 1.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4265ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f6efd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w3sus6arra",
    x1: 0.037,
    y1: 1.01,
    x2: 0.919,
    y2: 0.053,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59eefd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#416efe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ro35au5q2d",
    x1: 0.949,
    y1: 0.984,
    x2: 0.056,
    y2: 0.038,
    xlinkHref: "#w3sus6arra"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4814"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 3",
    d: "M33.381 0A7 7 0 0 1 39.5 3.6l8.611 15.5a7 7 0 0 1 0 6.8L39.5 41.4a7 7 0 0 1-6.119 3.6H16.619a7 7 0 0 1-6.119-3.6L1.889 25.9a7 7 0 0 1 0-6.8L10.5 3.6A7 7 0 0 1 16.619 0z",
    transform: "rotate(90 22.5 22.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4804"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53613",
    d: "m108.125 44.767-2.853 1.64a2.709 2.709 0 0 0-1.379-.357 2.806 2.806 0 0 0-2.805 2.782l-9.2 5.326a2.858 2.858 0 0 0-1.355-.333 2.714 2.714 0 0 0-1.45.4l-9.13-5.254v-.214a2.8 2.8 0 0 0-2.805-2.687H77a2.684 2.684 0 0 0-1.355.428L72.7 44.791l.071-.024 14.979-8.654a5.372 5.372 0 0 1 5.349 0l14.978 8.654h.048z",
    transform: "translate(-67.943 -31.348)",
    style: {
      fill: "url(#pnoku98cbc)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4805"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53614",
    d: "m168.182 83.8-3.019 1.64a1.256 1.256 0 0 1 .024.309 2.822 2.822 0 0 1-1.807 2.615v11.08a2.791 2.791 0 1 1-2.14.048V88.317a2.7 2.7 0 0 1-.618-.38l-3.115 1.688v6.824a1.992 1.992 0 1 1-1.688.1v-5.997l-4.089 2.235a2.454 2.454 0 0 1 .1.713 2.8 2.8 0 0 1-2.425 2.782v18.212l.048.024 15.929-8.678a5.269 5.269 0 0 0 2.829-4.636l-.024-17.4z",
    transform: "translate(-126.408 -68.241)",
    style: {
      fill: "url(#w3sus6arra)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4806"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53615",
    d: "M82.543 93.5a2.715 2.715 0 0 1 .119-.785L78.525 90.5v6.039a2 2 0 1 1-1.688-.1V89.6l-3.115-1.664a2.315 2.315 0 0 1-.571.357v11.032a2.9 2.9 0 0 1-1.189 5.54 2.9 2.9 0 0 1-1.022-5.611V88.365a2.793 2.793 0 0 1-1.807-2.5v-.38L65.924 83.8H65.9v17.4a5.249 5.249 0 0 0 2.9 4.636l16.334 8.678.048-.024V96.306a2.829 2.829 0 0 1-2.639-2.806z",
    transform: "translate(-62.76 -68.241)",
    style: {
      fill: "url(#ro35au5q2d)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4807"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53616",
    d: "M143.084 117.968a2.172 2.172 0 0 1-2.092 2.092h-.166a2.1 2.1 0 0 1-1.926-2.092 1.39 1.39 0 0 1 .048-.452 2.067 2.067 0 0 1 1.331-1.5 1.8 1.8 0 0 1 .713-.119 2.345 2.345 0 0 1 .571.071 2.113 2.113 0 0 1 1.5 1.64 1.8 1.8 0 0 1 .021.36z",
    transform: "translate(-118.404 -92.709)",
    style: {
      fill: "url(#13japk9g1b)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4808"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53617",
    d: "M199.284 85.368v.071a2.045 2.045 0 0 1-1.094 1.759 2.085 2.085 0 0 1-1 .262 1.8 1.8 0 0 1-.357-.024 2.323 2.323 0 0 1-.713-.262 2.077 2.077 0 0 1-1.022-1.783 3.222 3.222 0 0 1 .048-.476 2.093 2.093 0 0 1 2.045-1.617 1.773 1.773 0 0 1 .618.1 2.019 2.019 0 0 1 1.475 1.97z",
    transform: "translate(-161.242 -67.86)",
    style: {
      fill: "url(#8fl10j4bhe)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4809"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53618",
    d: "M199.284 153.892a2.092 2.092 0 1 1-4.184 0 2.069 2.069 0 0 1 .951-1.736 2.092 2.092 0 0 1 1.141-.357 2.017 2.017 0 0 1 1 .262 2.065 2.065 0 0 1 1.092 1.831z",
    transform: "translate(-161.242 -120.074)",
    style: {
      fill: "url(#bqb013tc4f)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4810"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53619",
    d: "M86.675 153.364a2.187 2.187 0 1 1-3.21-1.926 2.093 2.093 0 0 1 1.022-.238 2.06 2.06 0 0 1 1.189.357 2.088 2.088 0 0 1 .999 1.807z",
    transform: "translate(-75.261 -119.616)",
    style: {
      fill: "url(#illud99f7g)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4811"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53620",
    d: "M112.168 140.684a1.284 1.284 0 1 1-1.617-1.236 1.606 1.606 0 0 1 .333-.048 1.276 1.276 0 0 1 .951.428 1.2 1.2 0 0 1 .333.856z",
    transform: "translate(-96.07 -110.622)",
    style: {
      fill: "url(#g3ru00dxsh)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4812"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53621",
    d: "M177.468 140.684a1.284 1.284 0 0 1-2.568 0 1.2 1.2 0 0 1 .333-.856 1.276 1.276 0 0 1 .951-.428 1.606 1.606 0 0 1 .333.048 1.251 1.251 0 0 1 .951 1.236z",
    transform: "translate(-145.845 -110.622)",
    style: {
      fill: "url(#cdbvh6hefi)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4813"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53622",
    d: "M86.778 85.273a2.022 2.022 0 0 1-.547 1.5 1.719 1.719 0 0 1-.523.4 1.11 1.11 0 0 1-.238.119 2.253 2.253 0 0 1-.689.166h-.1a2.107 2.107 0 0 1-1.022-.262 2.085 2.085 0 0 1-1.07-1.664v-.048a2.022 2.022 0 0 1 .547-1.5 2.319 2.319 0 0 1 .808-.547 2.083 2.083 0 0 1 .642-.143h.1a2.1 2.1 0 0 1 2.068 1.759.59.59 0 0 1 .024.22z",
    transform: "translate(-75.484 -67.86)",
    style: {
      fill: "url(#z9t7w77irj)"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMganusmage);
export default __webpack_public_path__ + "static/media/mganusmage.eeadc72f28dcc4821c747dd9cb017c0e.svg";
export { ForwardRef as ReactComponent };